<template>
  <teleport to="body">
    <d-popup v-slot="{ close }" v-bind="$attrs" @closed="$emit('closed')">
      <div class="d-disclaimer-popup">
        <div v-if="dataTitle" class="d-disclaimer-popup__title" v-html="dataTitle"></div>
        <div v-if="dataText" class="d-disclaimer-popup__text" data-simplebar>
          <div class="d-disclaimer-popup__textInner" v-html="dataText" />
        </div>
      </div>
    </d-popup>
  </teleport>
</template>

<script>
import DPopup from '@components/molecules/DPopup.vue';

export default {
  name: 'DPopupDisclaimer',
  components: { DPopup },
  props: {
    dataTitle: {
      type: String,
      default: 'Материалы представленные на сайте не являются публичной офертой'
    },
    dataText: {
      type: String,
      default: '<p>Авторские права принадлежат группе компаний ООО «ДОНСТРОЙ» (далее в отношении соответствующей компании - правообладатель). Все права защищены. Никакие содержащиеся на Сайте материалы или их часть не могут быть воспроизведены, использованы или переданы третьим лицам в целях извлечения прибыли без предварительного согласия правообладателя в письменной форме.</p><p>Вся содержащаяся на Сайте информация носит исключительно справочно-информационный и ознакомительный характер, не является исчерпывающей и не является публичной офертой, определяемой положениями статьи 437 Гражданского кодекса РФ. Правообладатель не гарантирует абсолютные точность, полноту и достоверность информации, содержащейся на Сайте. Правообладатель оставляет за собой право в любой момент вносить изменения в содержащуюся на Сайте информацию без дополнительного уведомления. Информацию необходимо уточнять по телефонам компании. Правообладатель ни в коем случае не несет ответственности перед какими-либо лицами за ущерб или убытки, понесенные ими в результате использования информации, содержащейся на данном Сайте.</p><p>Вся содержащаяся на Сайте информация носит исключительно справочно-информационный и ознакомительный характер, не является исчерпывающей и не является публичной офертой, определяемой положениями статьи 437 Гражданского кодекса РФ. Правообладатель не гарантирует абсолютные точность, полноту и достоверность информации, содержащейся на Сайте. Правообладатель оставляет за собой право в любой момент вносить изменения в содержащуюся на Сайте информацию без дополнительного уведомления. Информацию необходимо уточнять по телефонам компании. Правообладатель ни в коем случае не несет ответственности перед какими-либо лицами за ущерб или убытки, понесенные ими в результате использования информации, содержащейся на данном Сайте.</p>'
    }
  }
};
</script>

<style scoped>

</style>
